<template>
    <div>
        <template v-if="! loading">
            <b-row class="justify-content-center">
                <b-col class="px-0 pb-2 col-10 col-md-8 col-lg-6">
                    <b-card>
                        <b-card-title title-tag="h5" title="Forgot Member Number"></b-card-title>
                        <b-card-sub-title v-if="errorMsg" sub-title-tag="div">
                            <span class="text-danger">{{ errorMsg }}</span>
                        </b-card-sub-title>
                        <b-card-body v-if="! success" class="px-0">
                            <b-form @submit="memberSearch($event)">
                                <b-form-group label="Email" label-for="email">
                                    <b-form-input id="email" v-model="member.email" type="email" required :readonly="processing"></b-form-input>
                                </b-form-group>
                                <b-form-group label="Forename" label-for="forename">
                                    <b-form-input id="forename" v-model="member.forename" type="text" required :readonly="processing"></b-form-input>
                                </b-form-group>
                                <b-form-group label="Surname" label-for="surname">
                                    <b-form-input id="surname" v-model="member.surname" type="text" required :readonly="processing" @keyup.enter="memberSearch"></b-form-input>
                                </b-form-group>
                                <b-button variant="primary" type="button" @click="memberSearch($event)" :disabled="processing">Remind Me</b-button>
                            </b-form>
                        </b-card-body>

                        <b-card-body v-else class="px-0 text-center">
                            <p>Member Record Found</p>
                            <div class="mb-4">
                                <i class="fas fa-check-circle text-success fa-3x fa-fw"></i>
                            </div>
                            <p>Please check your email for your member number.</p>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </template>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: false,
            errorMsg: false,
            member: {
                email: null,
                forename: null,
                surname: null,
            },
            processing: false,
            success: false,
        }
    },
    methods: {
        memberSearch(event) {
            event.preventDefault();
            this.errorMsg = false;
            this.processing = true;

            axios.post(this.$routes.route('bookings.forgot.process'), this.member)
                .then((response) => {
                    if (response.data.success) {
                        this.processing = false;
                        this.success = true;

                        setTimeout(() => {
                            window.location.href = this.$routes.route('bookings.login.index');
                        }, 5000);
                    } else {
                        this.errorMsg = response.data.message;
                        this.processing = false;
                    }
                })
                .catch((error) => {
                    this.errorMsg = error.response.data.message;
                    this.processing = false;
                });
        },
        init() {
            this.member.email = null;
            this.member.forename = null;
            this.member.surname = null;
            this.success = false;
            this.processing = false;
            this.errorMsg = false;
            this.loading = false;
        },
    },
    mounted() {
        this.loading = true;
        this.init();
    },
}
</script>